<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-checkbox
            :error-messages="error"
            v-model="isChecked"
        >
          <template #label>
            <div>
              {{ translation(translationList.rca_gdpr_agreement, 'Sunt de acord cu&nbsp;') }}
              <NuxtLink to="/info/terms-and-conditions" class="text-decoration-none">
                {{ translation(translationList.terms_agreement_link, 'termenii și condițiile.') }}
              </NuxtLink>
            </div>
          </template>
        </v-checkbox>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, watch, onMounted, type PropType } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  name: 'CustomerTermsAgreement',
  props: {
    modelValue: {
      type: [Boolean, null] as PropType<boolean | null>,
      default: false,
    },
  },
  setup(props, { emit }) {
    const isChecked = ref(props.modelValue);
    const translationList = ref<TranslationList>({});
    const translationStore = useTranslationStore();
    const error = ref([]);

    watch(isChecked, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(() => props.modelValue, (newValue) => {
      isChecked.value = newValue;
      error.value = [];
      const isValid = isChecked.value;
      emit('validation-customer-status', { field: 'terms_agreement', isValid });
    });

    onMounted(async () => {
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');

      // Listen for validate-terms and validate-customer events
      window.addEventListener('validate-terms', validateTerms);
      window.addEventListener('validate-customer', validateTerms);
    });

    const validateTerms = () => {
      if (!isChecked.value) {
        error.value = [translation(translationList.value.required, 'Te rugăm să citești și să accepți termenii și condițiile pentru a putea continua')];
      } else {
        error.value = [];
        emit('validation-customer-status', { field: 'terms_agreement', isValid: true });
      }
    };

    return {
      isChecked,
      translationList,
      translation,
      error,
    };
  },
});
</script>

<style scoped>
</style>
